import { memo } from "react";
import { Grid, Icon, Input, Popup } from "semantic-ui-react";
import { HandleInputChange } from "../../../../../custom-hooks/form/types";

type RouterNameProps = {
  onChange: HandleInputChange;
  placeholder: string;
  value?: string;
};

const RouterName = ({ onChange, placeholder, value }: RouterNameProps) => {
  return (
    <Grid.Row className="padding-top-10">
      <Grid.Column textAlign="left" width={8} className="flex vcenter ">
        <h5>
          Router Name
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            <p>
              Desired name for router.
              <br /> Defaults to "&lt;network.name&gt;-router"
            </p>
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <Input
          placeholder={placeholder}
          value={value}
          className="select-box full"
          name="routerName"
          onChange={onChange}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(RouterName);
